module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('landing'), _vm._v(" "), _c('hero')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea0a9626"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 50
// module chunks = 0